module.exports = __webpack_public_path__ + "img/icon-message-plus.b3dd4be.svg";